import { render, staticRenderFns } from "./BaseImageListWidget.vue?vue&type=template&id=2bd0cf08"
import script from "./BaseImageListWidget.vue?vue&type=script&lang=ts"
export * from "./BaseImageListWidget.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports